import PropTypes from 'prop-types'
import { useStyletron } from 'baseui'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import useNewsletterField from './useNewsletterField'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const NewsletterBonsPlans = ({ isNewsletterRegistered, disabled, emailHasError, hidden = false, hideInfo = false }) => {
  const [css] = useStyletron()
  const {
    sendNewsletter,
    email,
    newsletterCanBeSent,
    newsletterError,
    t,
    newsletterLoading,
    newsletterData,
    status,
    franceNoPdlNotRegistered,
    franceWithPdl,
    buttonOverrides,
  } = useNewsletterField(isNewsletterRegistered)

  const getNewsletterButtonText = (t, status, email) => {
    if (status === 'success') {
      return t('subscriptionForm:customer_module.newsletter.button_submitted') + '(' + email + ')'
    }
    if (status === 'already_subscribed') {
      return t('subscriptionForm:customer_module.newsletter.button_submitted_already_subscribed')
    }
    if (status === 'already_sent_recently') {
      return t('subscriptionForm:customer_module.newsletter.button_submitted_recently')
    }
    return t('subscriptionForm:customer_module.newsletter.button')
  }

  if (hidden) return null

  return (
    <>
      <SDNotification
        type='warning'
        hidden={hideInfo || !franceNoPdlNotRegistered}
        primaryText={t('subscriptionForm:customer_module.newsletter.not_personalized_warning')}
      />
      <SDNotification
        type='info'
        hidden={hideInfo}
        primaryText={
          franceWithPdl
            ? t('subscriptionForm:customer_module.newsletter.label_personalized')
            : t('subscriptionForm:customer_module.newsletter.label')
        }
      />
      <SDFormControl plainLabel error={newsletterError}>
        <SDButton
          block
          isLoading={newsletterLoading}
          disabled={!newsletterCanBeSent || emailHasError || disabled}
          onClick={sendNewsletter}
          overrides={buttonOverrides}
        >
          {getNewsletterButtonText(t, status, email)}
        </SDButton>
      </SDFormControl>

      {newsletterLoading && (
        <div
          className={css({
            alignItems: 'center',
            display: 'flex',
          })}
        >
          <p
            className={css({
              marginLeft: '10px',
            })}
          >
            {t('subscriptionForm:customer_module.newsletter.loading_info')}
          </p>
        </div>
      )}

      {status === 'error' && <SDNotification type='negative' primaryText={newsletterData?.response?.message} />}

      {(status === 'already_subscribed' || status === 'already_sent_recently') && (
        <SDNotification type='warning' primaryText={newsletterData?.response?.message} />
      )}

      {status === 'success' && <SDNotification type='positive' primaryText={newsletterData.response?.message} />}

      {emailHasError.length > 0 && (
        <SDNotification type='negative' primaryText={t('subscriptionForm:customer_module.email.error')} />
      )}
    </>
  )
}

NewsletterBonsPlans.propTypes = {
  isNewsletterRegistered: PropTypes.bool,
  disabled: PropTypes.bool,
  emailHasError: PropTypes.any,
  hidden: PropTypes.bool,
  hideInfo: PropTypes.bool,
}

export default NewsletterBonsPlans
